// ============================================================
// components/BackgroundBlobs.jsx — Decorative blurred circles
// ============================================================

import { useContext } from "react";
import { ThemeContext } from "../../../constant/theme";

const BackgroundBlobs = () => {
  const { theme } = useContext(ThemeContext);

  return (
    <div style={{ position: "absolute", inset: 0, pointerEvents: "none" }}>
      {/* Top-right blob */}
      <div
        style={{
          position:     "absolute",
          top:          "-140px",
          right:        "-120px",
          width:        "300px",
          height:       "300px",
          borderRadius: "50%",
          filter:       "blur(60px)",
          background:   theme === "light"
            ? "rgba(59,130,246,0.05)"
            : "rgba(99,102,241,0.1)",
        }}
      />
      {/* Bottom-left blob */}
      <div
        style={{
          position:     "absolute",
          bottom:       "-140px",
          left:         "-140px",
          width:        "320px",
          height:       "320px",
          borderRadius: "50%",
          filter:       "blur(60px)",
          background:   theme === "light"
            ? "rgba(139,92,246,0.05)"
            : "rgba(59,130,246,0.1)",
        }}
      />
    </div>
  );
};

export default BackgroundBlobs;